import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Renderer } from "@unseenco/taxi";

gsap.registerPlugin(ScrollTrigger);

import GlobalHandler from "../global/global";
import AnimationHandler from "../global/animations";
import ScrollHandler, { ScrollAnchors, lenis } from "../global/scroll";
import VideoHandler from "../global/video";
import MarginsHandler from "../global/margins";
import CarouselHandler from "../partials/carousel";
import HeaderHandler from "../partials/header";
import AccordionHandler from "../partials/accordion";
import FiltersHandler from "../partials/filters";
import ProductTableHandler from "../partials/product-table";
import TeamFeedHandler from "../partials/team-feed";
import SearchModal from "../partials/search-modal";
import Modal from "../partials/modal";
import CursorHandler from "../partials/cursor";
import ScrollbarHandler from "../partials/scrollbar";
import ContactFormHandler from "../partials/contact-form";
import FriendlyCaptchaHandler from "../partials/friendly-captcha";
import LottieHandler from "../global/lottie";
import FacilitiesMapHandler from "../partials/facilities-map";

const global = new GlobalHandler();
const animation = new AnimationHandler();
const scroll = new ScrollHandler();
const anchor = new ScrollAnchors();
const video = new VideoHandler();
const margins = new MarginsHandler();
const carousel = new CarouselHandler();
const header = new HeaderHandler();
const accordion = new AccordionHandler();
const searchModal = new SearchModal();
const modal = new Modal();
let filters = null;
const productTable = new ProductTableHandler();
const teamFeed = new TeamFeedHandler();
const cursor = new CursorHandler();
const scrollbar = new ScrollbarHandler();
const contactForm = new ContactFormHandler();
const friendlyCaptcha = new FriendlyCaptchaHandler();
const lottie = new LottieHandler();
const facilitiesMap = new FacilitiesMapHandler();

export default class RendererDefault extends Renderer {

    scrollToHash() {
        const { hash } = window.location;

        if (!hash) {
            lenis.scrollTo(0, { immediate: true });
            return;
        }

        const target = document.querySelector(hash);

        if (!target) {
            lenis.scrollTo(0, { immediate: true });
            return;
        }

        // Reset browser + Lenis position first
        window.scrollTo(0, 0);
        lenis.scrollTo(0, { immediate: true });

        requestAnimationFrame(() => {
            const header = document.querySelector('header');

            lenis.scrollTo(target, {
                duration: 1.2,
                offset: header ? (header.offsetHeight * -1) : 0,
            });
        });
    }

    initialLoad() {
        this.onEnter(
            global.viewHeight(),
            scroll.init(),
        );
        this.onEnterCompleted(
            header.init(),
        );
        cursor.init();
        scrollbar.init();
        friendlyCaptcha.init();
    }
    onEnter() {
        // lenis.scrollTo(0, { immediate: true });
        animation.animations();
        margins.init();
        carousel.init();
        accordion.init();
        filters = new FiltersHandler();
        filters.init();
        productTable.init();
        teamFeed.init();
        modal.init();
        video.customPlayer();
        header.initHeaderTheme();
        anchor.init();
        cursor.initHovers();
        lottie.init();
        facilitiesMap.init();
    }
    onEnterCompleted() {
        // lenis.scrollTo(0, { immediate: true });
        header.scroll();
        header.updateActiveLinks();
        searchModal.init();
        contactForm.initForm();
        friendlyCaptcha.init();
        this.scrollToHash();
        scrollbar.initScrollbar();
    }
    onLeave() {
    }
    onLeaveCompleted() {
        let triggers = ScrollTrigger.getAll();
        triggers.forEach((trigger) => {
            trigger.kill();
        });
        scrollbar.destroy();
        header.reset();
        teamFeed.destroy();
        cursor.destroy();
        contactForm.destroy();
        friendlyCaptcha.destroy();
        facilitiesMap.destroy();
    }
}